export default __webpack_public_path__ + "static/media/blueWave.3fe87fc6.svg";